module.exports = __webpack_public_path__ + "img/shogi_2021_pack_2_0003.a316fe8e.png";